/* eslint-disable */
import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'
import apiConfigs from 'Api/api-config'
import { getConfigKey, prepareHeaders } from 'utility/Api'
import {BaseQueryArg} from "@reduxjs/toolkit/dist/query/baseQueryTypes";

const baseUrl = apiConfigs[getConfigKey()].apiHost
const apiPath = apiConfigs[getConfigKey()].paths.apiPath

// Define a service using a base URL and expected endpoints
export const FrcApi = createApi({
  reducerPath: 'frcApi',
  baseQuery: fetchBaseQuery({
    baseUrl: `${baseUrl}/${apiPath}`,
    prepareHeaders: async headers => await prepareHeaders(headers)
  }),
  endpoints: builder => ({
    saveLogin: builder.query<boolean | string, void>({
      query: () => {
        return {
          url: `logins`,
          method: 'POST',
          body: {},
          responseHandler: async response => {
            const data = await response.json()
            return data
          }
        }
      }
    }),
    getReviews: builder.query<any[], string>({
      query: (documents: string) => {
        return {
          url: `reviews`,
          method: 'POST',
          body: {
            docIds: documents
          },
          responseHandler: async response => {
            const data = await response.json()
            return data // Need to specify this otherwise it tries to JSON.parse response, causing error
          }
        }
      },
      transformResponse: (response: any) => {
        return response[0][0]
      }
    }),
    getFinancialPeriods: builder.query<any, void>({
      query: () => {
        return {
          url: `financialPeriods`,
          method: 'GET',
          responseHandler: async response => {
            const data = await response.json()
            return data // Need to specify this otherwise it tries to JSON.parse response, causing error
          }
        }
      },
      transformResponse: (response: any) => {
        if (response.row !== undefined) {
          const transformed = response.row.map((row: any) => ({ period: row.SELPERIO, name: row.PERIO_TEXT })).sort((a: any, b: any) => b.period.localeCompare(a.period))
          return transformed
        } else return response
      }
    }),
    getReasonConfig: builder.query<any, void>({
      query: () => {
        return {
          url: `reasonConfig`,
          method: 'GET',
          responseHandler: async response => {
            const data = await response.json()
            console.log('reasonData', data)
            return data // Need to specify this otherwise it tries to JSON.parse response, causing error
          }
        }
      },
      transformResponse: (response: any) => {
        if (Array.isArray(response) && Array.isArray(response[0])) {
          const transformed = response[0].map((row: any) => ({
            reasonCode: row.RCODE,
            ord: row.ORD,
            reasonText: row.REASON
          }))
          console.log('reasonData tran', transformed)
          return JSON.parse(JSON.stringify(transformed))
        } else {
          return response
        }
      }
    }),
    getConfigReport: builder.query<any, void>({
      query: () => {
        return {
          url: `config/report`,
          method: 'GET',
          responseHandler: async response => {
            const data = await response.json()
            console.log('configReport', data)
            return data // Need to specify this otherwise it tries to JSON.parse response, causing error
          }
        }
      },
      transformResponse: (response: any) => {
        if (response.length !== undefined) {
          const transformed = response[0].map((row: any) => {
            return { items: row.items }
          })
          console.log('configReport tran', transformed)
          return JSON.parse(JSON.stringify(transformed))
        } else return response
      }
    }),
    getConfigReportById: builder.query<any, string>({
      query: (id: string) => ({
        url: `config/report/${id}`,
        method: 'GET',
        responseHandler: async response => {
          const data = await response.json()
          console.log('configReportById', data)
          return data
        }
      }),
      transformResponse: (response: any) => {
        if (response.length !== undefined) {
          const transformed = response[0].map((row: any) => ({ items: row.items }))
          console.log('configReportById tran', transformed)
          return JSON.parse(JSON.stringify(transformed))
        } else return response
      }
    }),
    saveConfig: builder.mutation<any, { name: string, profitCenters: any[], supervisors: any[], costObjects: any[] }>({
      query: ({ name, profitCenters, supervisors, costObjects }) => ({
        url: `config/report`,
        method: 'POST',
        body: { name, filter: { costObjects, supervisors, profitCenters } }
      })
    }),
    updateConfigById: builder.mutation<any, { id: string, name: string, profitCenters: any[], supervisors: any[], costObjects: any[] }>({
      query: ({ id, name, profitCenters, supervisors, costObjects }) => ({
        url: `config/report/${id}`,
        method: 'PUT',
        body: { costObjects: costObjects, supervisors: supervisors, profitCenters: profitCenters, name: name }
      })
    }),
    deleteConfigById: builder.mutation<any, { id: string }>({
      query: ({ id}) => ({
        url: `config/report/${id}`,
        method: 'DELETE',
      })
    })
  })
})

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const { useGetReasonConfigQuery, useSaveLoginQuery, useGetReviewsQuery, useGetFinancialPeriodsQuery, useGetConfigReportQuery, useGetConfigReportByIdQuery, useSaveConfigMutation, useUpdateConfigByIdMutation, useDeleteConfigByIdMutation } = FrcApi
/* eslint-enable */
